import * as slide from './slide'

module.exports = {
	slide:slide
}



/** WEBPACK FOOTER **
 ** ./src/actions/index.js
 **/